import {TableCell, TableRow} from "../../../components/table/CustomTable";
import {useDispatch} from "react-redux";
import CustomButton, {DangerButton, OutlinedButton} from "../../../components/CustomButton";
import CustomIcon from "../../../components/CustomIcon";
import {setManageFeatureModals} from "../../../redux/slices/permissionSlice";
import ChipGroup, {ChipSecondary} from "../../../components/Chips";
import {isEqual} from "lodash";
import React from "react";

export default function AddFeatureTableItem({feature}) {

  const dispatch = useDispatch();

  return <TableRow>
    <TableCell className="font-semibold">
      {feature.name}
    </TableCell>
    <TableCell>
      <ChipGroup className="mb-0 items-center">
          {
            (feature.permissions ?? []).map((p) => <ChipSecondary label={p.name} key={p.id}
                                                                  backgroundColor="bg-white"
                                                                  onClose={() => dispatch(setManageFeatureModals({modal: true, data: {feature, remove: p}, isConfirm: true}))}/>)
          }        
        <div className="link font-medium px-2 py-1.5 rounded hover:bg-blue-100 mb-1 border border-dashed" onClick={() => dispatch(setManageFeatureModals({
          modal: true,
          bulkPermission: true,
          data: feature
        }))}>+ Add Permission</div>
      </ChipGroup>
    </TableCell>
    <TableCell>
      <div className="flex space-x-2">

        <CustomButton isIconButton={true}
                      onClick={() => dispatch(setManageFeatureModals({modal: true, data: feature}))}>
          <CustomIcon icon="edit"/>
        </CustomButton>

        <DangerButton isIconButton={true}
                      onClick={() => dispatch(setManageFeatureModals({modal: true, data: {feature}, isConfirm: true}))}>
          <CustomIcon icon="delete"/>
        </DangerButton>

      </div>
    </TableCell>


  </TableRow>;
}
